import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

/* import custom tools */
import timestamp from '../../../assecs/plugin/timestamp'; 

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import fetch function */
import { MemberReview } from "../../../services/business";

const MemberAgree = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState({});
    const { data } = useSelector(state => state.model);
    
    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value }}) => {
        delete error[name];
        
        source[name] = value;
        
        setError(error);
        setSource(source);
    };

    const submitHandler = event => {
        event.preventDefault();
        const isAgree = event.target.name === 'agree' ? true : false;
        const isValidate = isAgree || validate();
        
        source.isAgree = isAgree;
        
        if (isValidate) {
            MemberReview({mId: data.mId, source: source})
            .then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                    dispatch(setAction());
                }
            });
        }
    };

    const validate = () => {
        const checkLists = ['rejectReason'];
        const _errors = {};

        checkLists.map( list => (
            (!source[list]) && ( _errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    return (
        <Modal show={ true } centered>
            <Modal.Header>Review Member</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <div className='label'>Member Email</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='email' value={ data.email } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Member Name</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='name' value={ `${data.firstName} ${data.lastName}` } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Employee No.</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='employeeNo' value={ data.employeeNo } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Department</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='department' value={ data.department } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Apply Date</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='registerTime' value={ timestamp.get(data.registerTime) } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Reject Reason</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='rejectReason' placeholder='please enter the reason when you reject.' is-required={`${error.rejectReason}`} onChange={ changHandler } />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" name="reject" variant="danger" data-shadow onClick={ submitHandler }>Reject</Button>
                        <Button type="button" name="agree" data-shadow onClick={ submitHandler }>Agree</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default MemberAgree;